import { Route, Routes } from "react-router-dom";
import WhatsAppMessageList from "./WhatsAppMessageList";
import PageNotFound from "../pageNoFound";
const WhatsappRoutes = () =>{
    return (
        <Routes>
            <Route
                index
                element={
                    <WhatsAppMessageList />
                }
            />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}
export default WhatsappRoutes;